<template>             
	<div class="card card-flush" :class="processando ? 'overlay overlay-block' : '' ">
        <div class="card-header" v-if="!headerhidden">
            <h3 class="card-title"> {{ titulo ?  translate( titulo )     : translate('cadastrar') }}  </h3> 
            <div class="card-toolbar">
                <slot name="action"></slot> 
            </div>
        </div>
        <div class="card-body">
            <div class="overlay-wrapper p-5"> 
                <slot></slot>
            </div> 
            <div class="overlay-layer rounded bg-dark bg-opacity-5" v-if="processando">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden"> {{ translate('processando') }} </span>
                </div>
            </div>
        </div> 
    </div> 
</template>


<script lang="ts"> 
    import { Prop } from 'vue-property-decorator';  
    import { Options, Vue  } from "vue-class-component";   
    import { useI18n } from "vue-i18n";

    @Options({
        name: "CadastroInline",
        components: {  },  
    }) 
    export default class  CadastroInline extends Vue { 
        
        @Prop( ) readonly processando!: any 
        @Prop( ) readonly titulo!: any 
        @Prop( ) readonly headerhidden!: boolean 

        private t = useI18n().t;
        private te = useI18n().te; 
        public translate = text => {
            if (this.te(text)) {
                return this.t(text);
            } else {
                return text;
            } 
        }
    } 
</script>

<style scoped>
    .card-body{
        padding-top: 0px;
    }
</style>